import { roles } from "../config/config";

export const dashboardPermissions = [
  roles.admin,
  roles.gestore,
  roles.developer,
  roles.contabile,
  roles.magazziniere,
  roles.grafico,
];

export const getDashboardPermissions = (userIsAgente) => [
  ...dashboardPermissions,
  userIsAgente,
];
